import { colors } from '../../colors';
import Next from '../../../../static/images/icons/Next';
import Prev from '../../../../static/images/icons/Prev';
var carousel = {
  arrowBgColor: colors.brightGreen,
  arrowHoverBgColor: colors.shamrock,
  arrowForeColor: colors.white,
  arrowPrevMarginRight: '4px',
  arrowNextMarginLeft: '4px',
  highlightColor: colors.black,
  paginationInactiveColor: colors.white,
  paginationActiveColor: colors.brightGreen,
  paginationBorderColor: colors.brightGreen,
  heroPaginationBorder: false,
  noBorderOnDesktopVariationAandB: true,
  heroPaginationInactiveColor: colors.white,
  heroPaginationInactiveColorMobile: colors.brightGreen,
  heroPaginationInactiveColorVariationC: colors.brightGreen,
  heroPaginationActiveColor: colors.brightGreen,
  heroPaginationBorderColor: colors.shamrock,
  bgColor: colors.white,
  iconNext: Next,
  iconPrev: Prev
};
export default carousel;